import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Pagination.css';

export default class Pagination extends Component {
    constructor(props) {
      super(props);
      this.state = {};
      this.changePage = this.changePage.bind(this);
    }
    changePage(page) {
        if (page === this.props.page) {
            return;
        }

        this.props.onPageChange(page);
    }
    render() {
        return (
            <div className="pagination-container">
                <Button className="paging-button prev" bsStyle="link" disabled={!this.props.canPrevious} onClick={() => this.changePage(this.props.page - 1)}>
                    <FontAwesomeIcon icon="caret-left"/>
                    <span className="previous-label">{this.props.previousText}</span>
                </Button>
                <span>
                    {this.props.pageText + ' ' + (this.props.page + 1)}
                </span>
                <Button className="paging-button next" bsStyle="link" disabled={!this.props.canNext} onClick={() => this.changePage(this.props.page + 1)}>
                    <span className="next-label">{this.props.nextText}</span>
                    <FontAwesomeIcon icon="caret-right"/>
                </Button>
            </div>
        )
    }
}
